<template>
   <div class="upload-wrapper">
      <div v-if="urls || readonly" class="img-wrap">
         <div v-if="urls" class="file-name">{{ fileName }}</div>
         <div v-if="!urls">暂无数据</div>
         <el-button v-if="!readonly" type="text" class="img-close" @click="onClose">
            <i class="el-icon-circle-cross"></i>
         </el-button>
      </div>
      <el-upload v-else drag :action="`${$util.domain}${actionUrl}`" :with-credentials="true" name="uploadFile"
         type="drag" :thumbnail-mode="true" :accept=accept :show-file-list="false" :before-upload="onBeforeUpload"
         :on-success="onSuccess" :on-error="onError" :on-remove="onRemove">
         <div>
            <i class="el-icon-upload"></i>
            <div class="el-dragger__text">
               将文件拖到此处，或<em>点击上传</em>
            </div>
         </div>
         <div class="el-upload__tip upload-tips" slot="tip">{{ tips }}</div>
      </el-upload>
   </div>
</template>

<script>
export default {
   props: {
      actionUrl: {
         type: String,
         default: "/adminapi/v1/basicTools/upload/one?uploadImageType=3",
      },
      accept: {
         type: String,
         default: "",
      },
      keys: {
         type: String,
         default: "keys",
      },
      urls: {
         type: String,
         default: "",
      },
      readonly: {
         type: Boolean,
         default: false,
      },
      tips: {
         type: String,
         default: "",
      },
   },

   data() {
      return {
         fileName: "",
         uploadUrl: "",
      };
   },

   watch: {
      urls: {
         handler(value) {
            this.uploadUrl = value;
            this.fileName = value.split('/').pop();
         },
         immediate: true,
      },
   },

   methods: {
      // 删除图片
      onClose() {
         this.uploadUrl = "";
         this.$emit("onUrls", this.uploadUrl, this.keys);
      },
      // 上传文件之前的钩子
      onBeforeUpload(file) {
         this.fileName = file.name || "";
      },
      // 上传成功钩子
      onSuccess(response) {
         if (response.error !== 10000) {
            this.$util.errorMsg("上传失败");
         } else {
            this.uploadUrl = response.data;
            this.$emit("onUrls", this.uploadUrl, this.keys);
         }
      },
      // 上传失败钩子
      onError(response) {
         this.uploadUrl = "";
         this.$emit("onUrls", this.uploadUrl, this.keys);
         if (response.status === 403) {
            this.SIGNOUT();
            location.href = "/#";
         }
         this.$util.errorMsg("上传失败");
      },
      // 删除图片钩子
      onRemove() {
         this.uploadUrl = "";
         this.$emit("onUrls", this.uploadUrl, this.keys);
      },
   },
};
</script>

<style scoped>
.upload-wrapper .img-wrap {
   position: relative;
   width: 100%;
   height: 180px;
   border: 1px solid #c0ccda;
   border-radius: 4px;
}

.upload-wrapper .file-name {
   width: 100%;
   height: 100%;
   text-align: center;
   display: flex;
   justify-content: center;
   align-items: center;
}

.upload-wrapper .img-close {
   position: absolute;
   top: -7px;
   right: -7px;
   padding: 0;
}

.upload-wrapper .upload-tips {
   text-align: left !important;
   line-height: 1;
   margin: 0px;
}

.el-dragger__text {
   padding: 0px 20px;
}
</style>


// WEBPACK FOOTER //
// UploadFile.vue?9ce72984